import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CoverImage } from './CoverImage';
import { InlineCta } from './InlineCta';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { mainProduct } from '../data/offer';
export function MainProduct() {
  const p = mainProduct;
  return <section className="bg-ivory px-5 py-14" data-id="element-162" data-mp="33kz4g2do4gzk">
      <SectionHeading eyebrow="Il sistema «Stampa & Insegna»" title="Cosa ricevi" accent="1 libro completo in PDF" sub="Teoria per te ed esercizi per la classe, tutto in un unico libro pronto da stampare." data-id="element-163" data-mp="44kdmkrojc1y" />
      <Reveal className="mt-9" data-id="element-164" data-mp="3r7yxmumssorg">
        <article className="overflow-hidden rounded-2xl border border-ivory-line bg-ivory-white shadow-soft" data-id="element-165" data-mp="3rbd16677740h">
          <div className="flex flex-col items-center bg-espresso px-5 pb-6 pt-7 text-center" data-id="element-166" data-mp="3mcjq0kfdvp3h">
            <div className="w-40" data-id="element-167" data-mp="2frqtiorpx5do">
              <CoverImage src={p.cover} alt={`Copertina del libro ${p.title}`} title={p.title} label={p.subtitle} data-id="element-168" data-mp="2auqxl6ol1j0a" />
            </div>
            <p className="mt-5 text-[10px] font-bold uppercase tracking-[0.18em] text-wood" data-id="element-169" data-mp="3a1luohmwh1rn">{p.label}</p>
            <h3 className="mt-1 font-display text-[30px] uppercase leading-[1.02] text-ivory" data-id="element-170" data-mp="3e1wdiuvsjmnx">{p.title}</h3>
            <p className="mt-1 font-serif text-base italic text-sand" data-id="element-171" data-mp="3050q1xeslsoc">{p.subtitle}</p>
            <span className="mt-4 rounded-full bg-wood px-4 py-1.5 text-sm font-bold text-espresso" data-id="element-172" data-mp="350g1yjt8pei4">
              Valore {p.value}
            </span>
          </div>
          <div className="p-5" data-id="element-173" data-mp="2v437vkts8ymu">
            <p className="text-[15px] leading-relaxed text-ink-body" data-id="element-174" data-mp="2v5efxwu9gsjr">{p.description}</p>
            <ul className="mt-4 space-y-2.5" data-id="element-175" data-mp="2hdpz5g92hfwg">
              {p.features.map(f => <li key={f} className="flex gap-3" data-id="element-176" data-mp="2mcku1gkb6uwx">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-leaf" data-id="element-177" data-mp="27e8xrb0ulo6a">
                    <CheckIcon className="h-3 w-3 text-white" strokeWidth={3.5} aria-hidden="true" data-id="element-178" data-mp="2cd2cf6rvfl81" />
                  </span>
                  <span className="text-[15px] font-medium text-ink" data-id="element-179" data-mp="1t9s4n0c0a1x0">{f}</span>
                </li>)}
            </ul>
          </div>
        </article>
      </Reveal>
      <InlineCta data-id="element-180" data-mp="1jidzabxdi7vy" />
    </section>;
}